import type React from 'react'

import css from './styles.module.css'

interface Props {
  messages: string[]
}

export const SubscriptionMessages: React.FC<Props> = ({ messages }) => {
  return (
    <ul className={css.subscription_messages}>
      {messages.map((message) => (
        <li key={message} className={css.message}>
          {message}
        </li>
      ))}
    </ul>
  )
}
